export default {
  farsi: "فارسی",
  english: "English",
  arabic: "العربیة",
  title: "زبان‌های فعال در اکسکوینو",
  confirmBtn: "تایید"
};
